
export const url = "https://botektrusty.com/wp-json/";
export const API_URL = "https://botektrusty.com/";


// export const url = "https://wordpress.shopatbags.store/wp-json/";
// export const API_URL = "https://wordpress.shopatbags.store/";


